export default "__VITE_ASSET__CJC$oevh__"